import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {ListItemType} from 'hiya-common/src/reducers/commonTypes'
import {http} from 'hiya-common/src/utils/axios'

export enum PageTypeEnum {
  win = 1,
  lose,
}

// 获取大富翁config页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96442583
export const lucky_rich_man_config = createAsyncThunk(
  'lucky_rich_man_config',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          'count_down' | 'history' | 'stage_list' | 'games' | 'doing_stage'
        >
      >
    >(
      '/live/activity/lucky_rich_man_config',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 获取大富翁Rank页 http://wiki.xunlei.cn/pages/viewpage.action?pageId=96442559
export const lucky_rich_man_rank = createAsyncThunk(
  'lucky_rich_man_rank',
  // 1是赢钱榜单，2是输钱榜单
  async (arg: {rank_type: 1 | 2; stage_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'list' | 'own'>>
    >('/live/activity/lucky_rich_man_rank', {
      ...arg,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export interface reward_item {
  type: 1 | 2 //	1 是赢钱记录，2是输钱记录
  date: string // 奖励时间
  rank: number //	排名
  cash_back: number //	奖励金币数
}
interface stage {
  stage_id: number //	阶段
  status: number //	状态	1是当前阶段
  date: string //	日期
}
interface game_item {
  name: string
  url: string
}
interface InitialStateType {
  // config页面
  count_down?: number
  history?: reward_item[]
  stage_list?: stage[]
  games?: game_item[]
  doing_stage?: number
  // 榜单信息
  list?: ListItemType[]
  own?: ListItemType
}

const initialState: InitialStateType = {}

export const LuckyGuySlice = createSlice({
  name: 'LuckyGuy',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(lucky_rich_man_config.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(lucky_rich_man_rank.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default LuckyGuySlice.reducer
export const LuckyGuyActions = LuckyGuySlice.actions
